// extracted by mini-css-extract-plugin
export default {"container":"on-z"};